import DataSource from 'devextreme/data/data_source';
import AntSimpleStore from './AntSimpleStore';

export default class AntSimpleDataSource {
    constructor(args) {
        this.config = args;

        this.dataStore = new AntSimpleStore(args);
        this.dataSource = new DataSource({
            store: this.dataStore.instance(),
            paginate: args.remotePaging !== undefined ? args.remotePaging : args.paginate !== undefined ? args.paginate : true,
            pageSize: args.pageSize !== undefined ? args.pageSize : args.defaultPageSize !== undefined ? args.defaultPageSize : 10,
            // Do not let a Store.push() cause DevExtreme to reload the remote
            // datasource. Targeted renderers manage their own visible update.
            reshapeOnPush: false,
            pushAggregationTimeout: 0
        });
    }

    reInit(args) {
        this.dataStore.reInit(args);
    }

    instance() {
        return this.dataSource;
    }

    updateItem(...params) {
        return this.dataStore.updateItem(...params);
    }

    patchRows(...params) {
        const previousRows = this.dataStore.getCurrentData() instanceof Array ? this.dataStore.getCurrentData().slice() : [];
        const nextRows = this.dataStore.patchRows(...params);
        const keyField = this.dataStore.options?.key || 'id';
        const getKey = (row) => (row && row[keyField] !== undefined && row[keyField] !== null ? row[keyField] : null);
        const previousByKey = new Map(previousRows.map((row) => [getKey(row), row]).filter(([key]) => key !== null));
        const nextByKey = new Map((nextRows || []).map((row) => [getKey(row), row]).filter(([key]) => key !== null));
        const changes = [];

        // Thứ tự đẩy: xoá → sửa → chèn theo vị trí tăng dần. Nguồn không phân trang
        // (paginate: false) của DevExtreme áp lệnh chèn đúng `index`, nên món mới nằm đúng
        // chỗ theo thứ tự sắp mà không phải dựng lại cả danh sách. Nguồn phân trang bỏ qua
        // lệnh chèn/xoá như trước.
        previousByKey.forEach((_, key) => {
            if (!nextByKey.has(key)) changes.push({ type: 'remove', key });
        });
        const inserts = [];
        (nextRows || []).forEach((row, index) => {
            const key = getKey(row);
            if (key === null) return;
            const previous = previousByKey.get(key);
            if (!previous) inserts.push({ type: 'insert', data: row, index });
            else if (previous !== row) changes.push({ type: 'update', key, data: row });
        });
        changes.push(...inserts);

        // AntSimpleStore is the source of truth, but DevExtreme List only
        // redraws changed cards after its datasource receives push changes.
        // This keeps socket patches targeted instead of forcing a full reload.
        if (changes.length > 0 && typeof this.dataSource?.store?.().push === 'function') {
            this.dataSource.store().push(changes);
        }
        return nextRows;
    }

    reloadFromCurrentData() {
        // Rebuild DevExtreme's loaded item collection from AntSimpleStore without
        // contacting the backend. Store.push cannot materialize inserts/removals
        // reliably while reshapeOnPush is disabled for targeted socket updates.
        this.dataStore.prepareCurrentDataReload();
        this.dataSource.pageIndex(0);
        return this.dataSource.reload();
    }

    getCurrentData() {
        return this.dataStore.getCurrentData();
    }

    clearCacheData() {
        this.dataStore.clearCacheData();
    }

    requestCacheRefresh(options) {
        this.dataStore.requestCacheRefresh(options);
    }
}
